import {
	IIncidentOpenIncidentsSummary,
	IIncidentCategoryBreakdownFilters,
} from 'types/VehicleIncidents';
import { useGetDashboardBreakdownByOpenIncidentsQuery } from 'redux/api/vehicleIncidents';
import DashboardIncidentOpenIncidentsBreakdownCard from '../DashboardIncidentOpenIncidentsBreakdownCard';
import DashboardCard from '../DashboardCard';
import Heading from 'components/atoms/Heading';
import IncidentOpenIncidentsAtAGlanceGraph from '../IncidentOpenIncidentsAtAGlanceGraph';
import { firstDayOfLastJuly } from 'utils/firstDayOfLastJuly';
import { formatDate } from 'utils/formatDate';

export interface IDashboardIncidentsMainOpenIncidents {
	pdfRef: React.RefObject<HTMLDivElement>;
	renderingPdf: boolean;
}

const DashboardIncidentsMainOpenIncidents: React.FC<
	IDashboardIncidentsMainOpenIncidents
> = ({ pdfRef, renderingPdf }) => {
	const fromDate = firstDayOfLastJuly();
	const filters: IIncidentCategoryBreakdownFilters = {
		dateFrom: formatDate(fromDate),
	};
	const { data } = useGetDashboardBreakdownByOpenIncidentsQuery(filters);
	const openIncidents: IIncidentOpenIncidentsSummary[] =
		data?.openIncidents || [];
	const graphOpenIncidents = data?.graphOpenIncidents || [];
	const renderClasses = renderingPdf ? '' : 'max-h-[600px] overflow-y-auto';

	return (
		<div className={`pt-6 ${renderingPdf ? '' : 'max-h-[700px]'}`} ref={pdfRef}>
			<Heading type="h3" className="mb-4 text-[24px]">
				All Open Incidents
			</Heading>
			<div className="flex space-x-[30px]">
				<div className="flex flex-col basis-2/5 min-w-[472px] items-stretch">
					<DashboardCard
						className={`basis-1/3 ${renderClasses} grow`}
						title="Open Incidents"
						total={data?.total}
						dividerColor="border-grey-200"
					>
						<DashboardIncidentOpenIncidentsBreakdownCard
							openIncidents={openIncidents}
							incidentPath="incidents"
							getExtraFilters={() => {
								return { ...filters };
							}}
						/>
					</DashboardCard>
				</div>
				<div className="flex flex-col basis-3/5 min-w-[472px] items-stretch">
					<DashboardCard
						className="basis-2/3 max-h-[600px] min-h-[600px] overflow-y-auto"
						title="Open Incidents at a Glance"
						dividerColor="border-grey-200"
					>
						<IncidentOpenIncidentsAtAGlanceGraph
							openIncidentData={graphOpenIncidents}
						/>
					</DashboardCard>
				</div>
			</div>
		</div>
	);
};

export default DashboardIncidentsMainOpenIncidents;
